<div class="main">
    @if (ui !== 0) {
    <div>
        @if (ui===3 || ui===5) {
        <edx-refresher id="edx-hero-refresh" (refresh)="refresh()" [name]="reloadStr"></edx-refresher>
        }
        <div class="header welcome">{{welcomeHeader}}</div>
        <div class="header user-name" title="{{userName}}">{{userName}}</div>
    </div>
    }
    @if (ui === 0) {
    <h1 class="header user-name" title="{{welcomeHeader}} {{userName}}">
        {{welcomeHeader}} {{userName}}
    </h1>
    }
    <div>
        <div class="user-info" [ngClass]="{modifier: !showPftaNotification}">
            <div><span>{{userLibraryGuide}} {{userLibrary}}</span></div>
            <div><span>{{userGroupGuide}} {{userGroup}}</span></div>
        </div>
        <div class="recent-item" [ngClass]="{modifier: !showPftaNotification}"
            title="{{RestAPI.itemToolTipText(this.recentButton?.desc)}}">
            @if (recentButton) {
            <h2 class="heading" [ngClass]="{modifier: !showPftaNotification}">{{recentButton.header}}</h2>
            }
            @if (recentButton) {
            <div class="iconicbutton" tabindex="0" role="link" (click)="doButton(recentButton.cmd, recentButton.desc)"
                (keyup.enter)="doButton(recentButton.cmd, recentButton.desc)"
                (keydown.space)="doButton(recentButton.cmd, recentButton.desc,$event)">
                <img src="{{recentButton.icon}}" alt="{{recentButton.header+' '+iconAltTextFromDesc(recentButton.desc)}}">
                @if (RestAPI.displayMiniStatus(this.recentButton.desc)) {
                <img class="overlaystatusicon" src="{{RestAPI.formatStatusIcon(this.recentButton.desc)}}"
                    alt="{{RestAPI.formatStatusText(this.recentButton.desc)}}">
                }
                @if (RestAPI.displaySecondMiniStatus(this.recentButton.desc)) {
                <img class="overlaystatusicon top right" src="{{RestAPI.formatSecondStatusIcon(this.recentButton.desc)}}"
                    alt="{{RestAPI.formatStatusText(this.recentButton.desc)}}">
                }
                @if (RestAPI.displayTopMiniStatus(this.recentButton.desc)) {
                <img class="overlaystatusicon top" src="{{RestAPI.formatTopStatusIcon(this.recentButton.desc)}}"
                    alt="{{RestAPI.formatStatusText(this.recentButton.desc)}}">
                }
                <span>{{recentButton.label}}</span>
            </div>
            }
        </div>
        <div class="section-checkedOut-upload">
            @if (checkedOutButton) {
            <div class="section checked-out">
                <h2 class="heading">{{checkedOutButton.header}}</h2>
                <div class="iconicbutton" tabindex="0" (click)="doButton(checkedOutButton.cmd)" role="link"
                    (keyup.enter)="doButton(checkedOutButton.cmd)"
                    (keydown.space)="doButton(checkedOutButton.cmd,undefined,$event)"
                    [title]="checkedOutButton.tooltip">
                    <img src="{{checkedOutButton.icon}}"
                        alt="{{this.localizer.getTranslation('DOC_STATUS.CHECKEDOUT')}}" />
                    <span class="checkouttext">{{checkedOutButton.label}}</span>
                    @if (checkedOutButton.failedWarningIcon) {
                    <img src="{{checkedOutButton.failedWarningIcon}}" alt="{{checkedOutButton.tooltip}}" />
                    }
                </div>
            </div>
            }
            @if (uploadButton) {
            <div class="section upload" tabindex="0" role="button" [aria-label]="uploadButton.header"
                [ngClass]="{dragover:showDragOver}" (click)="doButton(uploadButton.cmd)"
                (keyup.enter)="doButton(uploadButton.cmd)"
                (keydown.space)="doButton(uploadButton.cmd,undefined,$event)">
                <div class="upload-icon"></div>
                <div class="heading">{{uploadButton.header}}</div>
            </div>
            }
        </div>
        @if (showPftaNotification && pftaButton) {
        <div class="pfta">
            <div class="section pfta">
                <h2 class="heading" title="{{pftaButton.header}}">{{pftaButton.header}}</h2>
                <div class="iconicbutton">
                    <img src="{{pftaButton.icon}}" alt="{{pftaButton.label}}">
                    <span>{{pftaButton.label}}</span>
                </div>
            </div>
        </div>
        }
    </div>
</div>